import { SC } from '../helper/ServerCall';
import { pathSegment } from '../helper/queryString';

export const agencyUserService = {
    storeAgencyUser,
    getAgencyUser,
    editAgencyUser,
    deleteAgencyUser,
    getCurrentAgencyUser,
    updatePermission,
    getAgencyUsersPagination,
    getAllAgenciesUsersPagination
}

function storeAgencyUser(agencyId, agencyUserData) {
    return SC.postCall(`agencyUsers/${pathSegment(agencyId)}`, agencyUserData);
}

function getAgencyUser(agency_id, agencyUserId) {
    return SC.getCall(`agencyUsers/${pathSegment(agency_id)}/${pathSegment(agencyUserId)}/show`);
}

function editAgencyUser(agencyUserData, agencyUserId, agency_id) {
    return SC.putCall(`agencyUsers/${pathSegment(agency_id)}/${pathSegment(agencyUserId)}/update`, agencyUserData);
}

function deleteAgencyUser(agency_id, agencyUserId) {
    return SC.deleteCall(`agencyUsers/${pathSegment(agency_id)}/${pathSegment(agencyUserId)}/delete`);
}

function getAgencyUsersPagination(agency_id, page, filter, sort, pageSize) {
    return SC.getCall(`agencyUsers/${pathSegment(agency_id)}/listing`, { page, filter, sort, pageSize });
}

function getAllAgenciesUsersPagination(page, filter, sort, pageSize, is_active) {
    return SC.getCall('allAgenciesUsers', { page, filter, sort, pageSize, is_active });
}

function getCurrentAgencyUser() {
    return SC.getCall('getUsersData');
}

function updatePermission(agencyUserId) {
    return SC.getCall(`changePrimaryContact/${pathSegment(agencyUserId)}`);
}
